// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IElectionAmountDto
 */
export interface IElectionAmountDto {
    /**
     * 
     * @type {number}
     * @memberof IElectionAmountDto
     */
    min_election_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IElectionAmountDto
     */
    max_election_amount?: number;
}

/**
 * Check if a given object implements the IElectionAmountDto interface.
 */
export function instanceOfIElectionAmountDto(value: object): value is IElectionAmountDto {
    return true;
}

export function IElectionAmountDtoFromJSON(json: any): IElectionAmountDto {
    return IElectionAmountDtoFromJSONTyped(json, false);
}

export function IElectionAmountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IElectionAmountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'min_election_amount': json['minElectionAmount'] == null ? undefined : json['minElectionAmount'],
        'max_election_amount': json['maxElectionAmount'] == null ? undefined : json['maxElectionAmount'],
    };
}

export function IElectionAmountDtoToJSON(json: any): IElectionAmountDto {
    return IElectionAmountDtoToJSONTyped(json, false);
}

export function IElectionAmountDtoToJSONTyped(value?: IElectionAmountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minElectionAmount': value['min_election_amount'],
        'maxElectionAmount': value['max_election_amount'],
    };
}

